function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import ReactDatePicker from 'react-datepicker';
import { useTranslate } from 'shared/helper/translate';
import { parseValidators } from '../util';
import FormRow from './FormRow';
var Datepicker = function Datepicker(_ref) {
  var description = _ref.description,
    label = _ref.label,
    messages = _ref.messages,
    name = _ref.name,
    placeholder = _ref.placeholder,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    validators = _ref.validators,
    required = _ref.required,
    showTimeSelect = _ref.showTimeSelect,
    _ref$timeFormat = _ref.timeFormat,
    timeFormat = _ref$timeFormat === void 0 ? 'h:mm aa' : _ref$timeFormat,
    _ref$isClearable = _ref.isClearable,
    isClearable = _ref$isClearable === void 0 ? false : _ref$isClearable,
    _ref$timeIntervals = _ref.timeIntervals,
    timeIntervals = _ref$timeIntervals === void 0 ? 1 : _ref$timeIntervals,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'MM/dd/yyyy h:mm aa' : _ref$dateFormat,
    popperPlacement = _ref.popperPlacement,
    tooltip = _ref.tooltip;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  return /*#__PURE__*/React.createElement(FormRow, {
    messages: messages,
    required: typeof required !== 'undefined' ? required : !!validators,
    name: name,
    label: label,
    styles: _objectSpread(_objectSpread({}, styles), {}, {
      controls: "datepicker fs-ignore-rage-clicks ".concat(styles.controls || '')
    }),
    description: description
  }, /*#__PURE__*/React.createElement(Controller, {
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
        onChange = _ref2$field.onChange,
        onBlur = _ref2$field.onBlur,
        value = _ref2$field.value,
        name = _ref2$field.name;
      return /*#__PURE__*/React.createElement(ReactDatePicker, {
        id: name,
        className: "form-control datepicker ".concat(styles && styles.controlClass ? styles.controlClass : ''),
        isClearable: isClearable,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        selected: value,
        showTimeSelect: showTimeSelect,
        timeIntervals: timeIntervals,
        timeFormat: timeFormat,
        placeholderText: t(placeholder || ''),
        dateFormat: dateFormat,
        popperPlacement: popperPlacement,
        title: tooltip || ''
      });
    },
    name: name,
    control: control,
    rules: parseValidators({
      messages: messages,
      validators: validators
    })
  }));
};
export default Datepicker;